module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("Writing a book with another person, even your best friend, takes courage and commitment. It’s a testament to our long-standing and deep friendship and a deep commitment to collaboration that helped us bring this book into existence. We would like to dedicate this book to friendship, to the fundamental importance of love, to the power of maintaining a sense of humour and to the magical wonder of divine help and support.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0